import { SignalDispatcher, SimpleEventDispatcher } from 'strongly-typed-events';
import { DomHelper } from '../common/dom-helper';
import { EditorConfig } from '../common/editor-config';
import { IntegrationInfo } from '../common/integration-info';
import { UrlHelper } from '../customers-canvas-product-se-entry';
import { PriceProvider } from './price-provider';

export class SimpleEditorWrapper {

    private _onReady = new SignalDispatcher();
    private _onFinish = new SimpleEventDispatcher();

    public constructor(
        private _integrationInfo: IntegrationInfo, 
        private _editorConfig: EditorConfig, 
        private _priceProvider?: PriceProvider,
        private _frame?: {
            doc: Document,
            win: any,
        },
    ) {
        this.disableAutoBootstrapIfNeeded();
        this.addScriptsAndStylesToPage();
        this.initWithConfig();
        this.subscribeToEditorLoaded();
        this.subscribeToFinish();
    }

    get onReady() {
        return this._onReady;
    }

    get onFinish() {
        return this._onFinish;
    }

    get integrationInfo(): IntegrationInfo {
        return this._integrationInfo;
    }; 

    get element(): HTMLElement {
        return this.getFirstSimpleEditor();
    }

    public show() {
        const editorElement = this.getFirstSimpleEditor();
        // editorElement.hidden = false;

        editorElement.style.position = 'relative';
        editorElement.style.opacity = '1';
        editorElement.style.zIndex = '';
    }

    public hide() {
        const editorElement = this.getFirstSimpleEditor();
        // editorElement.hidden = true;

        editorElement.style.position = 'absolute';
        editorElement.style.opacity = '0';
        editorElement.style.zIndex = '-100';
    }

    private subscribeToEditorLoaded() {
        const _document = this._frame?.doc || document;
        _document.addEventListener('editorloaded', () => {
            this._onReady.dispatch();            
        });
    }

    private subscribeToFinish() {
        const editorElement = this.getFirstSimpleEditor();
        editorElement.addEventListener('addtocart', e => {
            this._onFinish.dispatchAsync(e);
        });
    }

    private getFirstSimpleEditor() {
        const _document = this._frame?.doc || document;
        return _document.getElementsByTagName('au-simple-editor')[0] as HTMLElement;
    }

    private addScriptsAndStylesToPage() {
        const frame = this._frame;
        const simpleEditorBaseUrl = this._integrationInfo.simpleEditorUrl;
        DomHelper.addCss(UrlHelper.urlCombine(simpleEditorBaseUrl, "styles.css"), "simple_editor_style", frame);
        DomHelper.addScript(UrlHelper.urlCombine(simpleEditorBaseUrl, "editor.js"), "se-source", frame);
    }

    private initWithConfig() {
        const _document = this._frame?.doc || document;
        _document.getElementById('se-source').addEventListener('load', this.sourceScriptLoadHandler.bind(this));
    }

    private async sourceScriptLoadHandler() {
        await this.bootstrapIfNeeded();
        const editorElement = this.getFirstSimpleEditor() as any;
        await editorElement.init(this._editorConfig);
    }

    private async bootstrapIfNeeded(){
        const win = this._frame?.win || window;
        if(this._priceProvider){
            await win.AurigmaWebComponents.simpleEditor.bootstrap([this._priceProvider]);
        }
    }

    private async disableAutoBootstrapIfNeeded(){
        const win = this._frame?.win || window;
        if(!this._priceProvider){
            return;
        }
        if (win.AurigmaWebComponents == null) {
            win.AurigmaWebComponents = {};
        }
        win.AurigmaWebComponents.simpleEditor = { autoBootstrapping: false };
    }
}